export default __webpack_public_path__ + "static/media/instagram.6987ee3c.svg";